import React from "react";
import useDealerSwr from "hooks/useDealerSwr";

/**
 * Displays a currency-formatted value based on the dealer's currencySymbol.
 *
 * @param {Object} props
 * @param {number|string} props.value - Value to display with currency
 */
export default function CurrencyValueDisplay({ value = "" }) {
    const { dealer, isLoading } = useDealerSwr();

    if (isLoading || !dealer) return null;

    const symbol = dealer.currencySymbol === "CAN" ? "CAN $" : "USD $";

    return <>{`${symbol}${value}`}</>;
}
